import axios from 'axios';
import { useEffect, useState } from 'react'
import Box from 'elements/Box';
import { Button, CircularProgress, IconButton, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Link } from 'react-router-dom';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { ProjectConfig } from 'Global';
import AlertDialog from 'elements/AlertDialog';


const RitualesCategoryList = () => {

  interface List {
    rituales_category_id: number;
    title: string;
  }

  const [loading, setLoading] = useState(false);
  const [list, setList] = useState<List[]>([]);
  const [total_pages, setTotalPages] = useState(0);

  const queryParams = new URLSearchParams(window.location.search);
  const currentPage = parseInt(localStorage.getItem('page') || "1");

  const [page, setPage] = useState(currentPage);
  const [refreshList, setRefreshList] = useState(0);


  /*=========================================================
  LOAD LIST            
  =========================================================*/

  useEffect(() => {

    setLoading(false)
    axios.get(ProjectConfig.api_url,
      {
        params: {
          request: 'rituales_category_list',
          page: page
        }
      })
      .then((response) => {
        console.log("Response:", response.data); 
        if (response.data && response.data.list) {
          setList(response.data.list)
          setTotalPages(response.data.total_pages)
        } else {
          console.error("Invalid API response:", response.data);
          setList([])
          setTotalPages(0)
        }
        setLoading(true)

      })
      .catch((err) => {
        console.log("API Error:", err);
        setList([])
        setLoading(true)
      })
    localStorage.setItem('page', page.toString())

  }, [page, refreshList])
  /*=========================================================*/




  /*=========================================================
  DELETE ITEM
  =========================================================*/

  const handleDelete = (id: number) => {
    setActiveItem(id)
    setOpenAlert(true)
  }


  const deleteItem = () => {
    axios.post(ProjectConfig.api_url, null,
      {
        params: {
          request: 'delete_rituales_category',
          id: activeItem,
        }
      })

      .then((response) => {
        console.log(response.data);
        setRefreshList(refreshList + 1)

      })
      .catch((err) => {
        console.log(err.data);
      })
      .then(() => {
        setOpenAlert(false)
      })
  }
  /*=========================================================*/

  const [openAlert, setOpenAlert] = useState(false);
  const [activeItem, setActiveItem] = useState<any>(null);

  return (
    <div id='RitualesCategoryList'>
      
      <div className='buttons_top'>
        <Button component={Link} to="add" variant="contained">
          Nueva Categoría
        </Button>
      </div>
        <div id="task_list_container" className="flex_container">
          
            <Box id='category_list' title="Ritos" subtitle="Categorías"  >
            {!loading && <div id='loader'><CircularProgress /></div>}
            <TableContainer>
            <Table stickyHeader aria-label="sticky table"> 
              <TableHead>
                <TableRow>
                  <TableCell>Título</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                  {list.map((list_item,i) => (
                    <TableRow 
                      
                      key={i}
                      hover
                      role="checkbox"
                    >
                      <TableCell onClick={()=> {window.location.href = `/admin/ritos/${list_item.rituales_category_id}`}} >    
                        <span className="clickable_title">{list_item.title}</span>
                      </TableCell>

                      <TableCell> 
                        <IconButton 
                          aria-label="edit" 
                          color="primary" 
                          component={Link} 
                          to={`/admin/ritos/categorias/edit/${list_item.rituales_category_id}`}
                        >
                          <span style={{fontSize: '14px'}}>Editar</span>
                        </IconButton>
                        <IconButton aria-label="delete"  color="primary" onClick={() => handleDelete(list_item.rituales_category_id)}>
                          <DeleteOutlineOutlinedIcon />
                        </IconButton>

                        <Button component={Link} to={`/admin/ritos/${list_item.rituales_category_id}`} variant="contained">
                          Ver Ritos
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          
          <Pagination count={total_pages} page={page}  onChange={(event, value) => {
            setPage(value)
          }
          } 
          color="primary"
          style={{"marginTop": "20px","alignSelf": "center"}}
          />
          </Box>
 
        </div>


        <AlertDialog
          open={openAlert}
          setOpen={setOpenAlert}
          subtitle="¿Está seguro de eliminar esta categoría y todos sus ritos?"
          send={deleteItem}
        />

    </div>
  );
};


export default RitualesCategoryList;
